<template>
    <div class="threejsContainer">
      <div class="containerTitle">1-19.报警灯<button @click="changeMe">报警灯切换</button></div>
      <div ref="container" class="containerBody"></div>
    </div>
  </template>
  
  <script>
  import * as THREE from 'three';
  import {generateScene} from '@/threejsEnv/scene.js';
  import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
  import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
  import {genRenderer} from '@/threejsEnv/renderer.js';
  
  export default {
    data() {
      return {
        scene: null,
        camera: null,
        renderer: null,
        controls: null,
        currentMesh: null,
        progress: 0,
        showLight: false,
        cube1: null,
        cube2: null,
        u_time: 0,
        window: {
          width: 0,
          height: 0
        },
        animationId: null
      };
    },
    mounted() {
      //初始化环境
      this.initEnv();
      //创建网格对象
      this.createMesh();
      this.animate();
      // 监听窗口大小变化
      window.addEventListener('resize', this.onWindowResize);
    },
    methods: {
      changeMe(){
        this.showLight = !this.showLight;
      },
      createMesh() {
        const geometry1 = new THREE.BoxGeometry();
        const material1 = new THREE.MeshBasicMaterial({ color: 0x00ff00});
      
        this.cube1 = new THREE.Mesh(geometry1, material1);
        this.cube1.position.x = 0.5;
        this.cube1.renderOrder = 1; 
        this.scene.add(this.cube1);
      
        const geometry2 = new THREE.BoxGeometry(0.3,0.3,0.3);
        const material2 = new THREE.MeshBasicMaterial({ color: 0xff0000 });
        this.cube2 = new THREE.Mesh(geometry2, material2);
        this.cube2.position.x = -0.15;
        this.cube2.renderOrder = 10; 
        this.scene.add(this.cube2);
      },
      animate() {
        this.animationId = requestAnimationFrame(this.animate);
        this.controls.update();
        this.renderer.render(this.scene, this.camera);
        if(this.showLight){
          this.cube2.material.depthTest = false;
        }else{
          this.cube2.material.depthTest = true;
        }
      },
      initEnv(){
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        // 初始化场景
        this.scene = generateScene();
        this.scene.background = new THREE.Color(0xffffff);
  
        // 初始化相机
        this.camera = genPerspectiveCamera(this.window);
  
        // 初始化渲染器
        this.renderer = genRenderer(this.window);
        this.$refs.container.appendChild(this.renderer.domElement);
  
        // 添加轨道控制器
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true;
  
        // 创建光源
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);
        
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(10, 20, 15);
        this.scene.add(directionalLight);
  
        const gridHelper = new THREE.GridHelper(100, 100,
                                                0x666666,   // 中心轴线颜色（红色）
                                                0xcccccc    // 普通网格线颜色（绿色）
                                                ); // 10x10 网格
        this.scene.add(gridHelper);
      },
      onWindowResize() {
        const width = this.$refs.container.clientWidth;
        const height = this.$refs.container.clientHeight;
  
        // 更新相机
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
  
        // 更新渲染器
        this.renderer.setSize(width, height);
      }
    },
    beforeDestroy() {
      // 清理动画和事件监听
      cancelAnimationFrame(this.animationId);
      window.removeEventListener('resize', this.onWindowResize);
      
      // 释放资源
      if (this.currentMesh) {
        this.scene.remove(this.currentMesh);
        this.currentMesh.geometry.dispose();
        this.currentMesh.material.dispose();
      }
      
      this.controls.dispose();
      this.renderer.dispose();
      this.renderer.domElement.remove();
    }
  };
  </script>
  
  <style>
  </style>
  